(function($) {
  $(
    ".mn-refresh .icon-col-grid .inner-container .icon-intro .col-wrap .img-wrap"
  ).matchHeight();
})(jQuery);
